(function() {
  const MOBILE_MAX_WIDTH = 1067;
  const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);

  function getElements() {
    return {
      group: document.querySelector('.thb-header-localization-group'),
      headerSlot: document.querySelector('[data-header-localization-slot]'),
      mobileMount: document.getElementById('mobile-header-localization-mount')
    };
  }

  function relocateLocalizationGroup() {
    const { group, headerSlot, mobileMount } = getElements();
    if (!group) return;

    const isMobile = mediaQuery.matches;

    if (isMobile && mobileMount) {
      if (!mobileMount.contains(group)) {
        mobileMount.appendChild(group);
      }
      group.classList.add('is-mobile-drawer');
      return;
    }

    if (headerSlot && !headerSlot.contains(group)) {
      headerSlot.appendChild(group);
    }
    group.classList.remove('is-mobile-drawer');
  }

  relocateLocalizationGroup();
  window.addEventListener('resize', relocateLocalizationGroup);
  document.addEventListener('DOMContentLoaded', relocateLocalizationGroup);
  window.addEventListener('load', relocateLocalizationGroup);

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', relocateLocalizationGroup);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(relocateLocalizationGroup);
  }
})();
